export default __webpack_public_path__ + "static/popover-light-mode-e4e1857b65ff6bfc3001134515266e41.mp4";